export default "__VITE_IMAGE_ASSET__012a3499__";